export const ApplicationStatus = {
  SESSION_ALIVE: 'SESSION_ALIVE',
  REJECTED: 'REJECTED',
  INSPECTION: 'INSPECTION',
  SUPPLEMENTING_REQUIRED: 'SUPPLEMENTING_REQUIRED',
  FROZEN: 'FROZEN',
  APPROVED: 'APPROVED',
  SIGNING_REQUIRED: 'SIGNING_REQUIRED',
  SIGNED: 'SIGNED',
  AUTHENTICATION_REQUIRED: 'AUTHENTICATION_REQUIRED',
  CUSTOMER_INTERACTION_REQUIRED: 'CUSTOMER_INTERACTION_REQUIRED',
  CUSTOMER_REDIRECTION_REQUIRED: 'CUSTOMER_REDIRECTION_REQUIRED',
  TIMED_OUT: 'TIMED_OUT',
  ACCOUNT_CREATION_FAILED: 'ACCOUNT_CREATION_FAILED',
  PSP_REDIRECTION_REQUIRED: 'PSP_REDIRECTION_REQUIRED',
  ESKAT_REQUIRED: 'ESKAT_REQUIRED',
  REQUIRES_LOWER_PURCHASE_AMOUNT: 'REQUIRES_LOWER_PURCHASE_AMOUNT',
  REQUIRED_FIELDS_MISSING: 'REQUIRED_FIELDS_MISSING',
  SIGNING_REQUEST_SENT: 'SIGNING_REQUEST_SENT',
  APPLICATION_PUSHED_OUT_TO_CUSTOMER: 'APPLICATION_PUSHED_OUT_TO_CUSTOMER',
  PAYMENT_PUSHED_OUT_TO_CUSTOMER: 'PAYMENT_PUSHED_OUT_TO_CUSTOMER',
}
